module.exports = __webpack_public_path__ + "img/jianjie.9afaa7d1.png";